import React from 'react'
import { Link } from 'react-router-dom'
import styles from './styles.css'

const TermsPrivacyMedical: React.SFC = () => (
  <p className={styles.legal}>
    By clicking Next you agree to the&nbsp;
    <Link to="/legal/terms-conditions" target="_blank" className={styles.link}>
      Terms of Use
    </Link>
    ,&nbsp;
    <Link to="/legal/privacy-policy" target="_blank" className={styles.link}>
      Privacy Policy
    </Link>
    &nbsp;and&nbsp;
    <Link to="/legal/medical-disclaimer" target="_blank" className={styles.link}>
      Medical Disclaimer
    </Link>.
  </p>
)

export default TermsPrivacyMedical
